import { Feature, MultiPolygon, Polygon } from 'geojson';
import { DeclareMethod } from '/imports/methods';

export interface LseRegion extends Feature<MultiPolygon | Polygon> {
  properties: {
    OBJECTID?: number | string;
    ID?: string;
    NAME?: string;
    TYPE?: string;
    CUSTOMERS?: number;
    [key: string]: any;
  };
}

export interface CcaLayerResult {
  image: string;
  bounds: { north: number, south: number, east: number, west: number };
}

export const listLseRegionsInPolygon = DeclareMethod<{ polygon: Polygon }, LseRegion[]>('listLseRegionsInPolygon');
export const getCcaLayer = DeclareMethod<{ polygon: Polygon, width: number, height: number }, CcaLayerResult | undefined>('getCcaLayer');
export const getCcaInfo = DeclareMethod<{ lat: number, lng: number }, { [key: string]: string } | undefined>('getCcaInfo');

// CEC GIS (ArcGIS) vector LSE layer — geojson features for a ProspectorMap layer (alongside CalCCA).
export interface CecLseFeature extends Feature<MultiPolygon | Polygon> {
  properties: {
    Utility?: string;
    Acronym?: string;
    Type?: string;
    URL?: string;
    Phone?: string;
    Address?: string;
    HIFLD_ID?: string;
    OBJECTID?: number;
    [key: string]: any;
  };
}
export const getCecLayer = DeclareMethod<{ polygon: Polygon }, CecLseFeature[]>('getCecLayer');
